<script setup lang="ts">
import './assets/style.scss'
import { useInventObjectLink } from './../model/model.ts'
import { useConfirm, VModal } from '@/shared/ui'
import { ObjectSearch } from '@/widgets'
import { useSendForm } from './../model/api.ts'
import { useTranslate } from '@/shared/lib'

const model = useInventObjectLink()
const { sendForm, isPending } = useSendForm()

const { show } = useConfirm()
const { trs } = useTranslate()

/**
 * Функция связывания объекта
 */
const submitHandler = () => {
  show({
    title: trs('itf.bind_object'),
    confirmFunc: () => sendForm(model.data).then(() => model.closeForm()),
  })
}
</script>

<template>
  <VModal :title="$t('itf.connection_to_object')" v-model="model.open">
    <VForm @submit.prevent="submitHandler" class="mt-2">
      <ObjectSearch
        v-model="model.data.object_to"
        :object_type="model.data.object_type"
        :label="$t('itf.connection_object')"
        fixed_height
        mock
      />

      <div class="form__btn_right mt-2">
        <VBtn color="default" @click="model.closeForm">{{ $t('itf.cancel') }}</VBtn>

        <VBtn type="submit" :disabled="!model.data.object_to || isPending">
          {{ $t('itf.bind') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
